module.exports = __webpack_public_path__ + "img/road-cars-day-thumb.40b0f15c.jpg";